import React, { Component } from "react";
import Hero from "./Hero.js";
import LogoBar from "./LogoBar.js";
import Testimonials from "./Testimonials.js";
import axios from "axios";
import _ from "lodash";
import { renderMarkup } from "../utils.js";
import { Link } from "react-router-dom";

class Home extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: null
    };
  }
  // componentDidUpdate(props) {
  //   if (!props.isLoading) {
  //     this.props.handleLoad(true);
  //   }
  // }
  componentDidMount() {
    const SITE_URL = "https://oncourse.dev-ggmm.com";

    axios.get(SITE_URL + "/wp-json/wp/v2/pages?slug=home").then(res => {
      this.setState(
        {
          data: res.data[0].acf
          //   pageTitle: res.data[0].title.rendered,
          //   seo: res.data[0].yoast_meta,
          //   pageContent: res.data[0].content.rendered,
          //   sectionTitle: res.data[0].acf.team_section_headline,
          //   featuredImage: res.data[0].better_featured_image.source_url
        },
        this.props.handleLoad()
      );
    });
  }

  render() {
    const { data } = this.state;
    if (data) {
      return (
        <div className="home">
          <Hero
            content={data.content_hero}
            linkTitle={data.link_title_hero}
            linkUrl={data.link_url_hero}
            image={data.background_image_hero}
            data={data}
          />
          <LogoBar page="Home" />
          <div className="bg-gray">
            <div className="inner">
              <div className="two-col">
                <div className="col-1">
                  <div
                    dangerouslySetInnerHTML={renderMarkup(
                      data.content_section1
                    )}
                  />
                </div>
                <div className="col-2">
                  {_.map(data.image_blocks_section1, (img, i) => {
                    return (
                      <div
                        key={i}
                        className="icon-block"
                        dangerouslySetInnerHTML={renderMarkup(img.content)}
                      />
                    );
                  })}
                </div>
              </div>
              <div className="three-col">
                {_.map(data.content_blocks_section1, (block, i) => {
                  return (
                    <div
                      key={i}
                      className="col"
                      dangerouslySetInnerHTML={renderMarkup(block.content)}
                    />
                  );
                })}
              </div>
              <Link to={data.link_url_section1} className="centered btn main">
                {data.link_title_section1}
              </Link>
            </div>
          </div>

          <div className="wrapper">
            <div className="inner">
              <div
                className="section-header"
                dangerouslySetInnerHTML={renderMarkup(data.section_header)}
              />
              <div className="image-wrapper mobile">
                {_.map(data.content_blocks_section2, (block, i) => {
                  return (
                    <div key={i} className="image-block">
                      <img src={block.icon} alt="Icon" />
                      <p
                        dangerouslySetInnerHTML={renderMarkup(block.content)}
                      />
                    </div>
                  );
                })}
              </div>
              <div className="image-wrapper desktop">
                <div className="i-block">
                  {_.map(data.content_blocks_section2, (block, i) => {
                    return (
                      <div key={i} className="image-block">
                        <img src={block.icon} alt="Icon" />
                      </div>
                    );
                  })}
                </div>

                <div className="p-block">
                  {_.map(data.content_blocks_section2, (block, i) => {
                    return (
                      <div key={i} className="text-block">
                        <p
                          dangerouslySetInnerHTML={renderMarkup(block.content)}
                        />
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
          </div>

          <div className="inner">
            <div className="image-left">
              <div className="left">
                <img src={data.image_section3} alt="FileBound" />
              </div>
              <div className="right">
                <div
                  dangerouslySetInnerHTML={renderMarkup(data.content_section3)}
                />
                <Link to="/products" className="btn main">
                  Learn More
                </Link>
              </div>
            </div>
          </div>
          <Testimonials />
        </div>
      );
    } else return false;
  }
}

export default Home;



// WEBPACK FOOTER //
// ./src/components/Home.js